module.exports = __webpack_public_path__ + "img/email-action-add.69f92b04.svg";